<template>
  <div class="chart" ref="chart"></div>
</template>

<script>
import { merge, isEmpty } from "lodash";
import echart from "echarts";
import { BASIC_OPTION, EMPTY_OPTION } from "./default_option";

export default {
  props: {
    // 业务数据
    dataList: {
      type: Array,
      default: () => []
    },
    // 特殊的样式定制
    extraOption: {
      type: Object,
      default: () => ({})
    },
    xData: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      chart: null
    };
  },
  watch: {
    dataList: {
      deep: true,
      handler(){
        this.updateChartView()
      }
    }
  },
  mounted() {
    this.chart = echart.init(this.$refs.chart);
    this.updateChartView();
    window.addEventListener("resize", this.handleWindowResize);
  },
  methods: {
    /**
     * 将业务数据加入到基础样式配置中
     * @returns {Object} 完整的echart配置
     */
    assembleDataToOption() {
      return merge(
        {},
        BASIC_OPTION,
        {
          series: this.dataList,
          xAxis:{data:this.xData}
        },
        this.extraOption
      );
    },

    /**
     * 更新echart视图
     */
    updateChartView() {
      if (!this.chart) return;
      const fullOption = isEmpty(this.dataList)
        ? EMPTY_OPTION
        : this.assembleDataToOption();
        console.log(fullOption)
      this.chart.setOption(fullOption, true);
    },

    /**
     * 当窗口缩放时，echart动态调整自身大小
     */
    handleWindowResize() {
      if (!this.chart) return;
      this.chart.resize();
    }
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.handleWindowResize);
  }
};
</script>

<style lang="less" scoped>
.chart {
  width: 100%;
  height: 100%;
}
</style>
